<template>
  <nav>
    <Sheet v-model:open="open">
      <SheetTrigger class="group rounded-full bg-dark-background p-1 text-light">
        <IconsMenu class="h-4 w-4" />
      </SheetTrigger>
      <SheetContent
        class="w-[76%] lg:max-w-2xl border-none px-0 pb-10 pt-0 max-lg:landscape:w-[50%]"
        :dir="dir"
        :side="dir === 'rtl' ? 'left' : 'right'"
      >
        <div
          class="relative h-10 after:absolute after:bottom-0 after:left-0 after:w-full after:h-px after:bg-[#999]/25 after:z-10 max-lg:after:scale-y-50"
        >
          <SheetClose
            class="absolute top-2 ltr:right-5 rtl:left-5 w-6 h-6 bg-dark-background rounded-full flex items-center justify-center"
          >
            <IconsMenuClose class="h-4 w-4" />
          </SheetClose>
        </div>
        <div class="h-full w-full overflow-auto">
          <slot />
        </div>
      </SheetContent>
    </Sheet>
  </nav>
</template>
<script lang="ts" setup>
import { Sheet, SheetContent, SheetTrigger } from '~/components/ui/sheet'
const route = useRoute()
const open = ref(false)
defineProps({
  dir: {
    type: String as PropType<'ltr' | 'rtl'>,
    default: 'ltr'
  }
})
watch(
  () => route.params,
  () => {
    open.value = false // Close sheet when navigating to a new route
  }
)
function resetOpen() {
  if (open.value && window.innerWidth >= 1024) {
    open.value = false
  }
}
onMounted(() => {
  window.addEventListener('resize', resetOpen)
})
onUnmounted(() => {
  window.removeEventListener('resize', resetOpen)
})
</script>
<style lang="scss">
@import './styles/index.scss';
</style>
